import { PageContainer } from './Home.styles';
import Overview from '@/components/Overview';
import Tiles from '@/components/Tiles';

export const Home = () => {
  return (
    <PageContainer>
      <Overview />
      <Tiles/>
    </PageContainer>
  )
};
